var page = 1;

window.slideTimer = function () {
    $('.nav-arrow-next').click();
};

$(function () {
    getHots();

    var id = $('#info_id').val();
    if (id) {
        var leader = getColumnList(id + 'js', 1, 1);
        if (leader && leader.data && leader.data.length > 0) {
            if (leader.data[0].thumbnail_urls.length > 0) {
                $('.leader-introduce-img img').attr('src', leader.data[0].thumbnail_urls[0] + '?w=91&h=120&s=3');
            }
            $('.leader-introduce-name').text(leader.data[0].title);
            $('.leader-introduce-body').text(leader.data[0].summary);
        }

        getList();
    }

    $('.list .more').on('click', function () {
        getList();
    });
});

function getContents(id) {
    var result = [];
    if (!id) return result;

    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/contents?id=' + id + '&page=' + page + '&size=10',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert('获取列表失败:' + data.message);
            else
                alert('获取列表失败');
        }
    });
    return result;
}

function getList() {
    var id = $('#info_id').val();
    var data;
    if (id == 'sj') {
        data = getColumnList('sjspj', page++, 10);
    } else if (id == 'zz') {
        data = getColumnList('ZZDT', page++, 10);
    }
    if (!data || data.message !== undefined || !data.data) {
        console.log(data);
        return;
    }
    var newlist = toListHtml(data);

    $('.list .newsItems').append(newlist);
    page++;

    if (data.data.length < 10) {
        $('.list .more').addClass('no-more');
    }

    if ($('.newsItem').length == 0) {
        $('.list .more').css('display', 'none');
        $('.list .newsItems').html('<div style="text-align: center;">暂无内容</div>');
    } else {
        $('.list .more').css('display', 'block');
    }
}

function toListHtml(data) {
    var newlist = '';
    for (var i = 0; i < data.data.length; i++) {
        var info = data.data[i];
        if (info.thumbnail_urls === undefined || info.thumbnail_urls == null || info.thumbnail_urls == '')
            info.thumbnail_urls = [];

        var bottominfo = '';
        bottominfo += '<div class="news_info">';
        // bottominfo += '<div class="user">' + info.author_nickname + '</div>';
        bottominfo += '<div class="time">' + info.publish_time + '</div>';
        bottominfo += '<div class="reply">';
        if (info.comment_count > 0)
            bottominfo += '<div class="reply_count">' + info.comment_count + '评论</div>';
        if (info.view_count > 0)
            bottominfo += '<div class="reply_count">' + info.view_count + '浏览</div>';
        bottominfo += '</div>';
        if (info.source)
            bottominfo += '<div class="source">来源: ' + info.source + '</div>';
        bottominfo += '</div>';

        newlist += '<div class="newsItem">';
        // 只显示有图和无图两种情况
        if (info.list_item_mode == 0 || info.thumbnail_urls.length == 0 || !info.thumbnail_urls[0]) { // 无图
            newlist += '<div class="newsInfo">';
            newlist += '<div class="news_body">';
            newlist += '<a class="news_title" href="' + info.url + '" target="_blank">' + info.title + '</a>';
            newlist += '<div class="news_content">';
            if (info.summary)
                newlist += info.summary;
            newlist += '</div>';
            newlist += '</div>';
            newlist += bottominfo;
            newlist += '</div>';
        } else {
            newlist += '<div class="newsPicture">';
            newlist += '<a href="' + info.url + '" target="_blank">';
            newlist += '<img src="' + info.thumbnail_urls[0] + '?w=200&h=150&s=3' + '"/>';
            newlist += '</a>';
            newlist += '</div>';
            newlist += '<div class="newsInfo">';

            newlist += '<div class="news_body">';
            newlist += '<a class="news_title" href="' + info.url + '" target="_blank">' + info.title + '</a>';
            newlist += '<div class="news_content">';
            if (info.summary)
                newlist += info.summary;
            newlist += '</div>';
            newlist += '</div>';
            newlist += bottominfo;
            newlist += '</div>';
        }
        newlist += '</div>';
        newlist += '<div class="dividing-line"></div>';
    }
    return newlist;
}

function getHots() {
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/hots',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            var newlist = '';
            for (var i = 0; i < data.length; i++) {
                var info = data[i];
                if (i < 3) {
                    newlist += '<div class="hots-item top3">';
                } else {
                    newlist += '<div class="hots-item">';
                }
                newlist += '<div class="hots-item-number">' + (i + 1) + '</div>';
                newlist += '<div class="hots-item-title"><a href="' + info.url + '" target="_blank">' + info.title + '</a></div>';
                newlist += '</div>';
            }

            $('.hots .hots-list').html(newlist);
        },
        error: function (data) {
            console.log(data);
        }
    });
}
